import { initializeClientApp } from './entries/initializeClientApp';
import { GalleryWidget } from '../src/GalleryWidget';
import { GalleryAttributes } from '../src/widgets/gallery/types';

initializeClientApp<GalleryAttributes>(GalleryWidget);
